import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';

import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { moduloPerform } from '../../diccionarios/performValuesModulo';


@Injectable({
  providedIn: 'root'
})

export class IoBasculaService {

  tvcModulo: any = {};
  urlIndustrias: any = {};
  url: string;

  constructor(private http: HttpClient, private _util: UtilsService, private commom: CommonService){
    this.tvcModulo      = moduloPerform;
    this.urlIndustrias  = this.tvcModulo.url.plcPerform;
    this.url            = this._util.getUrlIoIndustrias();
    //this.url            = "http://localhost:8080/industria-io-api/v1/api/services/";
  }

  // Services para crud y transacciones de la configuración de balanza/planta
  getAllBasculas(): Observable<any[]>{
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.basculaLinea.crudBascula);
  }
  
  saveBascula(payload): Observable<any[]>{
    return this.commom.peticionPostConHeader(this.url + this.tvcModulo.url.basculaLinea.crudBascula, payload);
  }

  updateBascula(payload): Observable<any[]>{
    return this.commom.peticionPutConHeader(this.url + this.tvcModulo.url.basculaLinea.crudBascula, payload);
  }

  deleteBascula(payload): Observable<any[]>{
    return this.commom.peticionPostConHeader(this.url + this.tvcModulo.url.basculaLinea.crudBascula, payload);
  }

  personaBascula(persona): Observable<any[]>{
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.basculaLinea.crudBascula + "/plantas/" + persona);
  }

  // Services para crud y transacciones de la captura de pesos por linea y planta
  savePesaje(payload): Observable<any[]>{
    return this.commom.peticionPostConHeader(this.url + this.tvcModulo.url.basculaLinea.crudPesos, payload);
  }

  //  @Path("ultimo/{basculaId}/{plantaId}/{lineaId}/{fecha}")
  lastPesaje(basculaId, plantaId, lineaId, fecha): Observable<any[]>{
    const PathParam = "/ultimo/"+basculaId+"/"+plantaId+"/"+lineaId+"/"+fecha;
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.basculaLinea.crudPesos + PathParam);
  }

  lastPesajeDiario(basculaId, plantaId, lineaId, fecha, material): Observable<any[]>{
    const PathParam = "/diario/"+basculaId+"/"+plantaId+"/"+lineaId+"/"+fecha+"/"+material;
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.basculaLinea.crudPesos + PathParam);
  }

  capturaPesaje(id): Observable<any[]>{
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.basculaLinea.capturaPeso+'/'+id);
  }

}